export class Structure {
    constructor(
        public code?: string,
        public libelle?: string,
        public disciplineId?: number
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/grhum/structure.model.ts